import { Box } from "@mui/material";

export const changeOrderColumns = ({ tableData, setTableData }) => [
  {
    id: "COData",
    header: "CO Data",
    columns: [
      {
        accessorKey: "coNumber",
        header: "CO #",
        enableEditing: false,
        size: 80,
      },
      {
        accessorKey: "date",
        header: "Date",
        muiEditTextFieldProps: { type: "date" },
        enableEditing: false,
        size: 80,
      },
      {
        accessorKey: "description",
        header: "Scope Description",
        enableEditing: false,
        size: 100,
      },
      {
        id: "responsible",
        accessorKey: "responsible",
        header: "By",
        size: 80,
        enableEditing: true,
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
      },
    ],
  },

  {
    id: "est",
    header: "Est. Data",
    columns: [
      {
        id: "est_bom", // ✅ unique id (was accessorKey "bom" duplicated)
        accessorKey: "bom",
        header: "BOM",
        enableEditing: false,
        size: 240,
        Cell: ({ row }) => {
          const arr = row.original.est_bom || [];

          return (
            <Box>
              {arr.map((t) => (
                <Box key={String(t)}> - {t}</Box>
              ))}
            </Box>
          );
        },
      },

      {
        accessorKey: "estManhours",
        header: "Manhours(hrs)",
        size: 20,
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
        muiEditTextFieldProps: ({ cell, row }) => ({
          type: "number",
          onChange: (e) => {
            // console.log("msnhour change", e);
            const value = e.target.value;
            // cell.setValue(value);
            setTableData((prev) => {
              const newData = [...prev];
              newData[row.index] = {
                ...newData[row.index],
                estManhours: value,
              };
              return newData;
            });
          },
        }),
      },

      {
        accessorKey: "estMaterialCost",
        header: "Material Cost",
        size: 20,
        enableEditing: true,
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
        muiEditTextFieldProps: ({ cell, row }) => ({
          type: "number",
          onChange: (e) => {
            const value = e.target.value;
            // console.log("value materialCost", e);
            // cell.setValue(value);
            setTableData((prev) => {
              const newData = [...prev];
              newData[row.index] = {
                ...newData[row.index],
                estMaterialCost: value,
              };
              return newData;
            });
          },
        }),
      },

      {
        accessorKey: "estOtherCost",
        header: "Other Cost",
        size: 20,
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
        muiEditTextFieldProps: ({ cell, row }) => ({
          type: "number",
          onChange: (e) => {
            const value = e.currentTarget.value;
            // cell.setValue(value);
            setTableData((prev) => {
              const newData = [...prev];
              newData[row.index] = {
                ...newData[row.index],
                estOtherCost: value,
              };
              return newData;
            });
          },
        }),
      },

      {
        id: "est_totalCost",
        accessorKey: "est_totalCost",
        header: "Total Cost",
        enableEditing: false,
        size: 20,
        muiTableHeadCellProps: {
          align: "center",
          sx: {
            fontWeight: 600,
            border: "0.5px solid rgba(81, 81, 81, .1)",
            padding: "10px",
            backgroundColor: "var(--pv-table-header-bg)",
          },
        },
        muiTableBodyCellProps: {
          align: "center",
          sx: {
            border: "1px solid rgba(81, 81, 81, .1)",
            padding: "10px",
            fontWeight: 600,
          },
        },
        Cell: ({ row }) => {
          const est_totalCost =
            Number(row.original.estMaterialCost) +
              Number(row.original.estOtherCost) || 0;
          return est_totalCost;
        },
      },
    ],
  },

  {
    id: "Actual",
    header: "Actual Data",
    columns: [
      {
        id: "actual_bom", // ✅ unique id (was accessorKey "bom" duplicated)
        accessorKey: "bom",
        header: "BOM",
        enableEditing: false,
        size: 240,
        Cell: ({ row }) => {
          const arr = row.original.actual_bom || [];

          return (
            <Box>
              {arr.map((t) => (
                <Box key={String(t)}> - {t}</Box>
              ))}
            </Box>
          );
        },
      },

      {
        id: "actual_manhours",
        accessorKey: "actual_manhours",
        header: "Manhours(hrs)",
        enableEditing: false,
        size: 20,
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
      },

      {
        id: "actual_materialsCost",
        accessorKey: "actual_materialsCost",
        header: "Material Cost",
        enableEditing: false,
        size: 20,
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
      },

      {
        id: "actual_other_cost",
        accessorKey: "Other Cost",
        header: "Other Cost",
        enableEditing: false,
        size: 20,
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
      },

      {
        id: "actual_totalCost",
        accessorKey: "actual_totalCost",
        header: "Total Cost",
        enableEditing: false,
        size: 20,
        muiTableHeadCellProps: {
          align: "center",
          sx: {
            fontWeight: 600,
            border: "0.5px solid rgba(81, 81, 81, .1)",
            padding: "10px",
            backgroundColor: "var(--pv-table-header-bg)",
          },
        },
        muiTableBodyCellProps: {
          align: "center",
          sx: {
            border: "1px solid rgba(81, 81, 81, .1)",
            padding: "10px",
            fontWeight: 600,
          },
        },
      },
    ],
  },

  {
    id: "profitLoss",
    header: "Profit/Loss",
    columns: [
      {
        accessorKey: "profit",
        header: "$$",
        size: 20,
        enableEditing: false,
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
        Cell: ({ row }) => {
          const est_totalCost =
            Number(row.original.estMaterialCost) +
              Number(row.original.estOtherCost) || 0;

          const profit = est_totalCost - row.original.actual_totalCost;

          return (
            <Box
              sx={{ fontWeight: "bold", color: profit >= 0 ? "green" : "red" }}
            >
              {profit}
            </Box>
          );
        },
      },
    ],
  },
];
